import React from 'react';
import { DateRow, PriceRow, TextRow, TypeRow } from 'components';
import { LoadDetailSwitcher } from '../loads';

export const corporateTxnsHead = [
  { name: 'loadId', title: 'Load ID', custom: false },
  { name: 'createdDate', title: 'Created. Date', custom: false, width: '140px' },
  { name: 'loadUd', title: 'Txns. Date', custom: false },
  { name: 'onModel', title: 'Type',
    filterList: [
      { name: 'All', id: 'All' },
      { name: 'Customer', id: 'CUSTOMER' },
      { name: 'Carrier', id: 'CARRIER' },
    ],
  },
  { name: 'customer', title: 'Customer', custom: false },
  { name: 'vendor', title: 'Vendor', custom: false },
  { name: 'customerAmt', title: 'Customer Amt', custom: false },
  { name: 'customerPaidAmt', title: 'Customer Paid', custom: false },
  { name: 'vendorAmt', title: 'Vendor Amt', custom: false },
  { name: 'vendorPaidAmt', title: 'Vendor Paid', custom: false },
  { name: 'totalAmount', title: 'Corp. Amt', custom: false },
  { name: 'description', title: 'Notes', custom: false, width: '250px' },
];

export const corporateTxnsBody = (openPrimary) =>  [
  { rowText: (item) => <div onClick={() => openPrimary(<LoadDetailSwitcher loadId={item?.load} />)} className='link-btn'>{item?.loadDisplayId}</div> },
  { rowText: (item) => <DateRow date={item?.loadCreatedDate} /> },
  { rowText: (item) => <DateRow date={item?.createdDate} /> },
  { rowText: (item) => <TypeRow text={item?.onModel} /> },
  { rowText: (item) => <TextRow name={item?.customer} /> },
  { rowText: (item) => <TextRow name={item?.vendor} /> },
  { rowText: (item) => <PriceRow info={item?.customerAmt} /> },
  { rowText: (item) => <PriceRow info={item?.customerPaidAmt} /> },
  { rowText: (item) => <PriceRow info={item?.vendorAmt} /> },
  { rowText: (item) => <PriceRow info={item?.vendorPaidAmt} /> },
  { rowText: (item) => <PriceRow minuse={item?.totalAmount < 0} info={item?.totalAmount}   /> },
  { rowText: (item) => <TextRow name={item?.description} textWidth={8} /> },
];

export const ACTION_TYPE = 'GET_CORPORATE_TXNS';

export const corporateTransactionsCsv = {
  type: 'corporateTransactionsCsv',
  dateFilter: true,
};
